/*
 * EMPLACEMENT RÉSERVÉ — remplacer par de vraies photos de chantier avec l'accord du client.
 * Les images ci-dessous sont des visuels d'illustration libres de droits (Unsplash).
 * Elles NE SONT PAS des réalisations d'O'RIZON 360. Pour remplacer : déposer vos photos
 * dans frontend/public/images/realisations/ et indiquer le chemin (ex. "/images/realisations/mon-chantier-avant.jpg").
 */
const u = (id, w = 1200) => `https://images.unsplash.com/${id}?crop=entropy&cs=srgb&fm=jpg&q=80&w=${w}`;

export const CATEGORIES = [
  { key: "all", label: "Toutes" },
  { key: "maconnerie", label: "Maçonnerie" },
  { key: "etancheite", label: "Étanchéité" },
  { key: "isolation", label: "Isolation" },
  { key: "equipements", label: "Équipements techniques" },
  { key: "renovation", label: "Rénovation complète" },
  { key: "entretien", label: "Entretien" },
];

export const REALISATIONS = [
  {
    id: "renovation-appartement-nogent",
    title: "Rénovation complète d'un appartement",
    category: "renovation",
    categoryLabel: "Rénovation complète",
    place: "Nogent-sur-Marne (94)",
    description: "Exemple de fiche : rénovation complète d'un T3 — démolition des cloisons, reprise des réseaux, chape, finitions.",
    before: u("photo-1503387762-592deb58ef4e"),
    after: u("photo-1600210492486-724fe5c67fb0"),
    gallery: [u("photo-1600585154340-be6161a56a0c"), u("photo-1600566753086-00f18fb6b3ea")],
  },
  {
    id: "etancheite-terrasse-vincennes",
    title: "Étanchéité d'une toiture-terrasse",
    category: "etancheite",
    categoryLabel: "Étanchéité",
    place: "Vincennes (94)",
    description: "Exemple de fiche : réfection complète de l'étanchéité d'une toiture-terrasse de copropriété, relevés et évacuations.",
    before: u("photo-1621905251189-08b45d6a269e"),
    after: u("photo-1635424710928-0544e8512eae"),
    gallery: [u("photo-1674485169641-bcb2bf6f1df9")],
  },
  {
    id: "maconnerie-ouverture-paris",
    title: "Ouverture d'un mur porteur",
    category: "maconnerie",
    categoryLabel: "Maçonnerie",
    place: "Paris 12e (75)",
    description: "Exemple de fiche : création d'une ouverture dans un mur porteur avec pose d'IPN, étaiement et reprises d'enduit.",
    before: u("photo-1581094794329-c8112a89af12"),
    after: u("photo-1484154218962-a197022b5858"),
    gallery: [u("photo-1684025295367-e0c115ec7745")],
  },
  {
    id: "isolation-combles-perreux",
    title: "Isolation de combles aménagés",
    category: "isolation",
    categoryLabel: "Isolation",
    place: "Le Perreux-sur-Marne (94)",
    description: "Exemple de fiche : isolation thermique et acoustique de combles aménagés, pare-vapeur et doublage en plaques de plâtre.",
    before: u("photo-1581094288338-2314dddb7ece"),
    after: u("photo-1513694203232-719a280e022f"),
    gallery: [],
  },
  {
    id: "equipements-vmc-creteil",
    title: "Installation d'une ventilation collective",
    category: "equipements",
    categoryLabel: "Équipements techniques",
    place: "Créteil (94)",
    description: "Exemple de fiche : installation et mise en service d'une VMC collective dans un immeuble de 12 logements.",
    before: u("photo-1621905252507-b35492cc74b4"),
    after: u("photo-1604709177225-055f99402ea3"),
    gallery: [],
  },
  {
    id: "entretien-parties-communes-fontenay",
    title: "Remise en état de parties communes",
    category: "entretien",
    categoryLabel: "Entretien",
    place: "Fontenay-sous-Bois (94)",
    description: "Exemple de fiche : reprise des enduits, peinture de la cage d'escalier et remplacement des éléments dégradés.",
    before: u("photo-1558618666-fcd25c85cd64"),
    after: u("photo-1472508249545-917598a8c985"),
    gallery: [],
  },
];
